export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  rearrangeCols: false,
  isCheckable: true,
  fields: [
    {
      name: 'field-generic-input',
      width: '35%',
      title: 'Item Name',
      id: 'name',
      sortField: 'name',
      prop: 'name',
      defaultVisible: true,
    },
    {
      name: 'field-generic-input',
      width: '35%',
      title: 'Description',
      id: 'desc',
      prop: 'desc',
      defaultVisible: true,
    },
    {
      name: 'catId',
      width: '30%',
      title: 'Catalog ID',
      id: 'catId',
      prop: 'catId',
      sortField: 'catId',
      defaultVisible: true,
    },
  ],
};
